module.exports = __webpack_public_path__ + "static/media/icon_hotel_notice.b27d5a30.svg";